<brightside-web-required-legal-documents
  *ngIf="showConsents && (loanPartnerInfo|async) as partner"
  [documentsKey]="partner.legalDocumentsKey"
  (termsSubmittedEvent)="termsAccepted($event)">
</brightside-web-required-legal-documents>
<bw-action-article-legacy *ngIf="!showConsents">
  <div content-section>
    <div class="flex-column space-center">
      <bw-spinner-legacy></bw-spinner-legacy>
      <typography-legacy text-medium-semibold>
        {{ 'SENDING_INFORMATION' | translate }}
      </typography-legacy>
    </div>
  </div>
</bw-action-article-legacy>
